export const styles = {
  loader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    right: '$2',
    top: '$2',
    zIndex: '$overlay',
  },
};
